// extracted by mini-css-extract-plugin
module.exports = {"overlay":"changeWallet_overlay__EqLpp","content":"changeWallet_content__15up_","button":"changeWallet_button__gINB8"};